import { createStytchUIClient } from '@stytch/nextjs/ui';

export const stytch = createStytchUIClient(
    process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN ?? ''
);

export const STYTCH_ERRORS_MAP: Record<string, string> = {
    invalid_token:
        'Oops, it seems like that link format is invalid. Please sign in again.',
    unable_to_auth_magic_link:
        'Oops, it seems like that link has expired. Please sign in again.',
};

export * from './userMasquerade';
export * from './signOut';
